import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { push } from 'react-router-redux'
import { compose, lifecycle } from 'recompose'

import config from 'config'
import * as actions from 'modules/auth/actions'

import LoadingPage from 'layouts/LoadingPage'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    regenerateCode: actions.regenerateCode,
    push
  }, dispatch),
})

export default compose(
  connect(undefined, mapDispatchToProps),
  lifecycle({
    async componentDidMount() {
      const isExistingDriftAccountSignIn = window.location.search.includes('third_party_signin') && !!localStorage.getItem('hyfy_state')
      const isNewAccount = !!localStorage.getItem('hyfy_state')
      
      if (isExistingDriftAccountSignIn) {
        this.props.actions.push('/video/survey')
      } else if (isNewAccount) {
        this.props.actions.regenerateCode()
      } else {
        // came directly from chrome store
        window.location.replace(`${config.DRIFT_VIDEO_LOGIN_REDIRECT_URL}?access_type=webstore`)
      }
    },
  }),
)(LoadingPage)



// WEBPACK FOOTER //
// ./src/layouts/VideoLandingStep/index.js